import { render, staticRenderFns } from "./FilterBarSubgenrePills.vue?vue&type=template&id=444ac1b7&scoped=true"
import script from "./FilterBarSubgenrePills.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterBarSubgenrePills.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterBarSubgenrePills.vue?vue&type=style&index=0&id=444ac1b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444ac1b7",
  null
  
)

export default component.exports